import { DataTableCol } from "../../../components/data-table/types";

export const IgmDataGridCols: DataTableCol[] = [
    {
        title: 'BAP Id',
        control: 'bap_id',
        sortable: true,
        canShowColumn: true,
    },
    {
        title: 'Category',
        control: 'category',
        sortable: true,
        canShowColumn: true,
    },
    {
        title: 'Sub Category',
        control: 'sub_category',
        sortable: true,
        canShowColumn: true,
    },
    {
        title: 'Issue Type',
        control: 'issue_type',
        sortable: true,
        canShowColumn: true,
    },
    {
        title: 'Issue Id',
        control: 'issue_id',
        sortable: true,
        canShowColumn: true,
    },
    {
        title: 'Created Date',
        control: 'created_dt',
        sortable: true,
        canShowColumn: true,
    },
    {
        title: 'Status',
        control: 'ticket_status',
        sortable: true,
        canShowColumn: true,
    },
    {
        title: 'Messages',
        control: 'view',
        canShowColumn: true,
    }
];